/**
 * Format a unix timestamp (ms) as a relative French string.
 *   < 60s          → "à l'instant"
 *   < 60 min       → "il y a N min"
 *   < 24h          → "il y a N h"
 *   < 7j           → "il y a N j"
 *   else           → "DD/MM/YYYY"
 */
export function formatRelative(dateMs: number, now: number = Date.now()): string {
  if (!Number.isFinite(dateMs)) return '';
  const diff = Math.max(0, now - dateMs);
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return "à l'instant";
  const min = Math.floor(sec / 60);
  if (min < 60) return `il y a ${min} min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `il y a ${hr} h`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `il y a ${day} j`;
  const d = new Date(dateMs);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
